import type { TrophyBadgeItem } from '../../logic/trophies'
import type User from '../../model/User'
import TrophyCase from '../badges/TrophyCase'
import AppIcon from '../icons/AppIcon'
import Chip from '../primitives/Chip'
import Eyebrow from '../primitives/Eyebrow'
import ProfileHero from './ProfileHero'
import styles from './ProfileScreen.module.css'

interface ProfileViewProps {
  user: User
  teamName?: string
  challengeName: string
  trophies: TrophyBadgeItem[]
  onTeamClick?: () => void
}

export default function ProfileView({
  user,
  teamName,
  challengeName,
  trophies,
  onTeamClick,
}: ProfileViewProps) {
  const details = [
    { label: 'Home base', value: user.homeBase },
    { label: 'Hype song', value: user.hypeSong },
  ].filter((detail) => detail.value)
  const snacks = user.getRoadTripSnacksList()
  const earnedCount = trophies.filter((trophy) => trophy.earned).length

  return (
    <>
      <ProfileHero firstName={user.firstName} lastName={user.lastName} photoUrl={user.photoUrl}>
        <Eyebrow>{teamName ?? 'No team'}</Eyebrow>
        <h2 className={styles.name}>
          {user.firstName} {user.lastName}
        </h2>
        {user.bio && <p className={styles.bio}>&ldquo;{user.bio}&rdquo;</p>}
        {onTeamClick && (
          <button type="button" className={styles.textLink} onClick={onTeamClick}>
            View team
            <AppIcon icon="mdi:chevron-right" size={16} />
          </button>
        )}
      </ProfileHero>

      {details.length > 0 && (
        <div className={styles.detailsGrid}>
          {details.map((detail) => (
            <div key={detail.label} className={styles.stat}>
              <span>{detail.label}</span>
              <strong>{detail.value}</strong>
            </div>
          ))}
        </div>
      )}

      {user.whyChallenge && (
        <section className={styles.story}>
          <h3>Why&apos;d ya say yes to {challengeName}?</h3>
          <p>{user.whyChallenge}</p>
        </section>
      )}

      {snacks.length > 0 && (
        <section className={styles.snacks}>
          <h3>Fave road trip snacks</h3>
          <div className={styles.chips}>
            {snacks.map((snack) => (
              <Chip key={snack} label={snack} />
            ))}
          </div>
        </section>
      )}

      {trophies.length > 0 && (
        <section className={styles.trophies}>
          <div className={styles.sectionHead}>
            <h3>Trophy case</h3>
            <span>
              {earnedCount} of {trophies.length} earned
            </span>
          </div>
          <TrophyCase trophies={trophies} />
        </section>
      )}
    </>
  )
}
